import { fetchWithdrawalsList } from '../../../../api/funds';
import { reactive } from 'cdui-js';
import { FundCard } from './FundCard';

export const WithRecords = () => {
  const state = reactive({
    list: [],
  });

  const fetchList = async () => {
    const res = (await fetchWithdrawalsList()) as any;
    state.list = res.list;
  };

  fetchList();

  return (
    <div>
      {state.list.map((row) => {
        return <FundCard data={row} />;
      })}
    </div>
  );
};
